import { MyJoi } from "@sr-partner-portal/common";

const resumeValidationSchema = MyJoi.object({
    name: MyJoi.myString().min(3).max(40).required(),
    email: MyJoi.myString().myEmailAddress().required(),
    phone: MyJoi.myString()
        .pattern(/^\+?[0-9\s-()]{6,20}$/)
        .required(),
    street: MyJoi.myString().myAddressStreet().required(),
    postalCode: MyJoi.myString().myAddressPostalCode().required(),
    city: MyJoi.myString().myAddressCity().required(),
    status: MyJoi.string()
        .valid("single", "married", "")
        .empty("")
        .default(null)
        .allow(null),
    numberOfChildren: MyJoi.number()
        .integer()
        .min(0)
        .max(20)
        .empty("", "null")
        .default(null)
        .allow(null),
    birthDate: MyJoi.date()
        .min("01/01/1950")
        .empty(["", "null"])
        .allow(null),
}).required();

export { resumeValidationSchema };
